import {Fragment, h} from 'preact';
import Button from '../form/Button';
import Dialog from '../media/Dialog';
import {useCallback, useState} from 'preact/hooks';
import ArchiveJobsForm from './ArchiveJobsForm';
import {Job} from '../../model/Job';

interface Props {
  jobs: Job[];
  onSuccess?(): any;
}

export default function ArchiveJobsButton({jobs, onSuccess}: Props) {
  const {length} = jobs
  if (length === 0)
    return null;

  const [showDialog, toggleDialog] = useState(false);

  const dialog = {
    show: toggleDialog.bind(null, true),
    hide: toggleDialog.bind(null, false)
  };

  const click = useCallback((event: MouseEvent) => {
    event.stopPropagation();
    dialog.show();
  }, [dialog]);

  return (
    <Fragment>
      <Button
        small={true}
        onClick={click}
        children="Archive"
        tooltip={`Archive${length > 1 ? ` ${length}`:''} Job${length === 1 ? '':'s'}`}
      />
      <Dialog show={showDialog} onRequestClose={dialog.hide}>
        {showDialog && (
          <ArchiveJobsForm
            jobs={jobs}
            onCancel={dialog.hide}
            onSuccess={() => {
              dialog.hide();
              if (onSuccess) onSuccess();
            }}
          />
        )}
      </Dialog>
    </Fragment>
  )
}